import { render, staticRenderFns } from "./administrationPostDetail.vue?vue&type=template&id=9e7ce1b6&scoped=true&"
import script from "./administrationPostDetail.vue?vue&type=script&lang=js&"
export * from "./administrationPostDetail.vue?vue&type=script&lang=js&"
import style0 from "./administrationPostDetail.vue?vue&type=style&index=0&id=9e7ce1b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e7ce1b6",
  null
  
)

export default component.exports